<div #bcElement [class]="cssClass"></div>
